import { zodResolver } from '@hookform/resolvers/zod'
import { useCallback } from 'react'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { useCurrentUserSetting } from '~/hooks'

import {
  Button,
  Command,
  CommandGroup,
  CommandItem,
  CommandList,
  Form,
  FormFieldInput,
} from '@hap/components'

import { useFilterMutator } from '../hooks'

export function DnisFilterControl() {
  const { onSelect, selection } = useFilterMutator()
  const [history, setHistory] = useCurrentUserSetting(
    'lookup',
    'dnisHistory',
    [] as string[],
  )
  const form = useForm({
    resolver: zodResolver(schema),
    values: { dnis: selection[0] || '' },
  })

  const selectDnis = useCallback(
    (dnis: string) => {
      onSelect([dnis])
      setHistory([dnis, ...history.filter((entry) => entry !== dnis)].slice(0, 6))
    },
    [history, onSelect, setHistory],
  )

  const onSubmit = form.handleSubmit(({ dnis }) => selectDnis(dnis))

  const handleRemove = useCallback(
    (dnis: string) => setHistory(history.filter((entry) => entry !== dnis)),
    [history, setHistory],
  )

  return (
    <Form {...form}>
      <form onSubmit={onSubmit} className="relative flex items-stretch gap-1 p-2">
        <FormFieldInput
          autoFocus
          control={form.control}
          name="dnis"
          className="grid flex-1"
          placeholder="Enter DNIS"
        />
        <Button
          type="submit"
          icon="check"
          size="icon"
          className="absolute top-1/2 right-4 shrink-0 -translate-y-1/2"
        />
      </form>
      {history.length > 0 && (
        <Command>
          <CommandList>
            <CommandGroup heading="History">
              {history.map((dnis) => (
                <CommandItem key={dnis} value={dnis} onSelect={() => selectDnis(dnis)}>
                  <span className="grow">{dnis}</span>
                  <Button
                    icon="x"
                    size="icon-sm"
                    variant="ghost"
                    className="shrink-0 opacity-0 group-aria-selected:opacity-100"
                    onClick={(event) => {
                      event.stopPropagation()
                      handleRemove(dnis)
                    }}
                  />
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      )}
    </Form>
  )
}

const schema = z.object({
  dnis: z.string().trim().min(1, 'Enter a DNIS'),
})
